// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoriteSection_container__1SA9P","buttons":"FavoriteSection_buttons__2iFsp"};